import React, { useContext } from "react";
import "./CommonPromptFilePage.css";
import { arrow } from "../../utils/images/index";
import { queryCallInsightsData } from "../../api/Postaction";
import { MyContext } from "../../context/ContextApi";
import { getSourceData } from "../../api/GetActions";

function SearchQueryField({ inputValue, placeholder, setInputData }) {
  const {
    fileNameExtract,
    setQueryResponse,
    setQuery,
    setSourceCallIn,
    setSourceDataCallIn,
    setGenerating,
  } = useContext(MyContext);

  const user = sessionStorage.getItem("firstname");

  const handleInputChange = (e) => {
    setInputData(e.target.value);
  };

  const handleQueryClick = async () => {
    setGenerating(true);
    let body = {
      user_name: user,
      filename: fileNameExtract,
      question: inputValue,
    };
    setQuery((prev) => [...prev, inputValue]);
    try {
      let res = await queryCallInsightsData(body);
      setQueryResponse((prev) => [
        ...prev,
        {
          response: res?.response,
        },
      ]);
      setGenerating(false);
      let res_1 = await getSourceData(user);
      if (res_1) {
        setSourceCallIn(true);
        setSourceDataCallIn(res_1?.transcript);
      }
      setInputData("");
    } catch (err) {
      setGenerating(false);
      console.log(err);
    }
  };

  return (
    <div className="input-wrapper">
      <div className="input-container-callIn">
        <input
          type="text"
          placeholder={placeholder}
          className="input-box-callIn"
          onChange={handleInputChange}
          value={inputValue}
        />
        <img
          className="arrow-button"
          src={arrow}
          alt=">"
          onClick={handleQueryClick}
        />
      </div>
    </div>
  );
}

export default SearchQueryField;
